import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

const data = [
  { day: "Mon", reach: 1200, orders: 220 },
  { day: "Tue", reach: 1800, orders: 300 },
  { day: "Wed", reach: 1500, orders: 280 },
  { day: "Thu", reach: 2500, orders: 500 },
  { day: "Fri", reach: 3200, orders: 700 },
  { day: "Sat", reach: 4100, orders: 900 },
  { day: "Sun", reach: 3700, orders: 760 },
];

const PromotionChart = () => {
  return (
    <ResponsiveContainer width="100%" height={320}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id="orangeFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ff6b00" stopOpacity={0.25} />
            <stop offset="95%" stopColor="#ff6b00" stopOpacity={0.02} />
          </linearGradient>
          <linearGradient id="blackFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#0f172a" stopOpacity={0.15} />
            <stop offset="95%" stopColor="#0f172a" stopOpacity={0.01} />
          </linearGradient>
        </defs>

        <CartesianGrid
          vertical={false}
          stroke="#e2e8f0"
          strokeDasharray="4 4"
        />

        <XAxis
          dataKey="day"
          tickLine={false}
          axisLine={false}
          tick={{ fontSize: 12, fill: "#64748b", fontWeight: 500 }}
        />

        <YAxis
          tickLine={false}
          axisLine={false}
          ticks={[0, 1500, 3000, 4500, 6000]}
          domain={[0, 6000]}
          tick={{ fontSize: 11, fill: "#94a3b8", fontWeight: 500 }}
          tickFormatter={(value) => `${value}`}
        />

        <Area
          type="monotone"
          dataKey="reach"
          stroke="#ff6b00"
          strokeWidth={4}
          fill="url(#orangeFill)"
          activeDot={{ r: 6, stroke: "#ff6b00", strokeWidth: 2, fill: "white" }}
        />

        <Area
          type="monotone"
          dataKey="orders"
          stroke="#0f172a"
          strokeWidth={3}
          fill="url(#blackFill)"
          activeDot={{ r: 5, stroke: "#0f172a", strokeWidth: 2, fill: "white" }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default PromotionChart;